import styles from './sidebar-navigation.module.css';
import { Accordion } from 'radix-ui';
import { UserClient } from '@/app/lib/schemas/types/shared';
import { BranchWithParsedCases } from '@/app/lib/schemas/types/branch-types';
import SidebarBranchesAccordion from './sidebar-branches-accordion';
import SidebarAccountAccordion from './sidebar-account-accordion';

interface Props {
  branches: BranchWithParsedCases[];
  pathname: string;
  user: UserClient | null;
  onClick: () => void;
  onLogin: () => void;
  onSignUp: () => void;
  onLogout: () => void;
  isAuthEnabled: boolean;
}

export default function SidebarNavigation({
  branches,
  pathname,
  user,
  onClick,
  onLogin,
  onSignUp,
  onLogout,
  isAuthEnabled
}: Props) {
  const root = pathname.split('/');
  const slug = root.find(s => s !== '');
  const defaultValue = `/${slug}`;

  return (
    <Accordion.Root
      className={styles.Root}
      type='single'
      defaultValue={defaultValue}
      collapsible
    >
      <SidebarBranchesAccordion
        branches={branches}
        pathname={pathname}
        onClick={onClick}
      />
      {isAuthEnabled && (
        <SidebarAccountAccordion
          user={user}
          pathname={pathname}
          onClick={onClick}
          onLogout={onLogout}
          onLogin={onLogin}
          onSignUp={onSignUp}
        />
      )}
    </Accordion.Root>
  );
}
